// extracted by mini-css-extract-plugin
module.exports = {"similarVenuesContainer":"yLBzPynFCPYw7PjEEs0d7","similarVenueCards":"_2TiJgOVvICXJ7cPw1KYRHL","venueContainer":"_3U2YnnloUq9xg4TaHtj9eQ"};